<div class="fx-row fx-align-center fx-gap-3 text-grey-400 mt-2 p-2">
  <ng-content></ng-content>
  <div class="border-grey-300 border-t-1 w-full" style="border-style: dashed;"></div>
</div>
<ng-content select="[menu-item-content]"></ng-content>
